module.exports = __webpack_public_path__ + "img/IMG_6258_L_Wood_MockedUp.5d1e6b4c.jpg";